import { Component, HostBinding, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-home-item',
  templateUrl: './home-item.component.html',
  styleUrls: ['./home-item.component.scss'],
})
export class HomeItemComponent {
  @Input() public iconClass?: string;
  @Input() public name?: string;
  @Input() public subheading?: string;
  @Input() public routeLink?: string;
  @Input() public uri?: SafeUrl;
  @Input() public target?: string;
  @Input() public inverted?: boolean;
  @Input() public actionLabel?: boolean;
  @Input() public isAuthenticated?: boolean;
  @HostBinding('class') hostClass: string = 'col-xs-12 col-lg-6';
}
